import { CreateElement } from "vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Input } from "element-ui";

function getDecimalStringFormatter(decimalPoints: number) {
  function formatNumber(value: string): string {
    value = value.replace(",", ".");
    value = value.replace(/[^0-9.]+/gm, ""); // remove non-numeric characters

    if (!value) return "";
    let integerPart, decimalPart;
    [integerPart, decimalPart] = value.split(".");

    if (!decimalPart) decimalPart = "";

    decimalPart = decimalPart
      .padEnd(decimalPoints, "0")
      .substring(0, decimalPoints);

    integerPart = integerPart.replace(/^0+/gm, ""); // remove leading zeros
    if (!integerPart.length) integerPart = "0";

    return integerPart + "." + decimalPart;
  }
  return formatNumber;
}

@Component({
  components: {},
})
export default class DecimalStringInput extends Vue {
  @Prop({ required: true })
  value!: string;

  @Prop({ default: 2 })
  precision!: number;

  @Prop({ default: false })
  disabled!: boolean;

  internalValue: string = this.value || "";

  render(h: CreateElement) {
    return h(
      Input,
      {
        on: this.listeners,
        props: {
          value: this.internalValue,
          disabled: this.disabled,
          clearable: true,
        },
        attrs: this.$attrs,
      },
      [
        h("template", { slot: "suffix" }, [this.$slots.suffix]),
        h("template", { slot: "prefix" }, [this.$slots.prefix]),
        h("template", { slot: "append" }, [this.$slots.append]),
        h("template", { slot: "prepend" }, [this.$slots.prepend]),
      ],
    );
  }

  get listeners() {
    return {
      ...this.$listeners,
      input: (val: string) => {
        this.internalValue = val;
      },
      change: (val: string) => {
        if (val === "") this.$emit("input", null);
        else {
          const newValue = this.stringFormatter(val);
          this.$emit("input", newValue);
          this.updateInternalValue(newValue);
        }
      },
    };
  }

  @Watch("value")
  updateInternalValue(value: string) {
    this.internalValue = value;
  }

  get stringFormatter(): (val: string) => string {
    return getDecimalStringFormatter(this.precision);
  }
}
